module.exports = __webpack_public_path__ + "images/icons/flags/KR-fc3da227.svg";